import { Machine } from '@interfaces/machines';
import { isPhone } from './platform';
import { machineStatus } from './statuses/machineStatus';
import { ncFileStatuses } from './statuses/ncFileStatus';
import { subStatusName } from './statuses/subStatus';

export const OPERATION_MACHINE_LINK_TYPE = {
  Preferred: 'Preferred',
  ScheduledOn: 'ScheduledOn',
  ProducedOn: 'ProducedOn',
  Alternative1: 'Alternative1',
  Alternative2: 'Alternative2',
};

export const OPERATION_MACHINE_LINK_TYPE_PRIORITIES = {
  [OPERATION_MACHINE_LINK_TYPE.ProducedOn]: 1,
  [OPERATION_MACHINE_LINK_TYPE.ScheduledOn]: 2,
  [OPERATION_MACHINE_LINK_TYPE.Preferred]: 3,
  [OPERATION_MACHINE_LINK_TYPE.Alternative1]: 4,
  [OPERATION_MACHINE_LINK_TYPE.Alternative2]: 5,
};

export const MACHINE_REFERENCE_ACTION = {
  LINK: 'add',
  UNLINK: 'remove',
};

export const OPERATION_ACTION = {
  LINK: 'add',
  UNLINK: 'remove',
};

export const machineDetailsConditions = ({
  status,
  ncFileStatus,
  subStatus,
  ncFileExist,
}: {
  status: string;
  ncFileStatus: string | null;
  subStatus: string;
  ncFileExist: boolean;
}) => {
  const isNotProductive = status === machineStatus.NOTPRODUCTIVE;

  const machineOffline = !ncFileStatus;

  const ignoredNcFile = isNotProductive && ncFileStatus === ncFileStatuses.Ignored;
  const noSelectedNCFileSubStatusButNCFileExist = subStatus === subStatusName.NoNcFileSelected && ncFileExist;

  const scrollDisable = !isPhone || machineOffline || ignoredNcFile;

  const machineActive = !machineOffline && !ignoredNcFile;

  return {
    isNotProductive,
    machineActive,
    machineOffline,
    ignoredNcFile,
    scrollDisable,
    noSelectedNCFileSubStatusButNCFileExist,
  };
};

export const getMachineBackgroundByState = ({
  status,
  machineActive,
  machineOffline,
  ignoredNcFile,
}: {
  status: string;
  machineActive: boolean;
  machineOffline: boolean;
  ignoredNcFile: boolean;
}) => {
  const activeColors = () => {
    switch (status) {
      case machineStatus.ACTIVE:
        return 'Panel / Dark / Active';
      case machineStatus.CHANGE:
        return 'Panel / Dark / Change';
      case machineStatus.SETUP:
        return 'Panel / Dark / Setup';
      case machineStatus.NOTPRODUCTIVE:
        return 'Panel/Light/Not Productive';
      default:
        return 'Panel / Dark / Active';
    }
  };

  if (machineActive) {
    return activeColors();
  }

  if (machineOffline) {
    return 'Panel/Light/Not Productive';
  }

  if (ignoredNcFile) {
    return 'Button/Light/Operator Panel [Not Productive]';
  }
  return activeColors();
};

export const ALL_MACHINES = 'all';

export const getMachineImageData = (machine: Record<string, unknown>) => {
  return {
    imageData: {
      isCropped: machine?.machineImage?.isCropped,
      extensionDerivative: machine?.machineImage?.extensionDerivative,
      pageNumber: machine?.machineImage?.imagePageDetails?.[machine?.machineImage?.pageNumber - 1]?.pageNumber,
      rotationAngle: machine?.machineImage?.imagePageDetails?.[machine?.machineImage?.pageNumber - 1]?.rotationAngle,
    },
    imageRandomHash: machine?.machineImage?.contentHash ?? machine?.machineStatus?.imageRandomHash,
    imageRotationAngle: machine?.machineImage?.imagePageDetails?.[machine?.machineImage?.pageNumber - 1]?.rotationAngle,
    machineDocumentId: machine?.machineImage?.documentId,
  };
};

export const isConnectorEffectivelyOnline = (machines: Machine[]): boolean => {
  return machines.some((m) => m?.machineStatus?.status && m.machineStatus.status !== machineStatus.NOTPRODUCTIVE);
};
